module.exports = __webpack_public_path__ + "img/menu-background-right.2074c307.png";